import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { ModelState } from '@personal-area/global/state';
import { User, UserOptions } from '@personal-area/global/users/models';
import { UserExtras } from '@personal-area/users'

import { UserState } from '../reducers/user';

const INIT_USER_STORE = '[User] Init store';
const GET_USER = '[User] Get user';
const GET_USER_SUCCESS = '[User] Get user success';
const GET_USER_FAIL = '[User] Get user fail';
const SET_USER_LOADING = '[User] Set user loading';
const UPDATE_USER = '[User] Update user';
const UPDATE_USER_OPTIONS = '[User] Update user options';
const UPDATE_USER_EXTRAS = '[User] Update user extras';

export const GetUser = createAction(GET_USER, (userId: number) => ({ userId }));
export const GetUserSuccess = createAction(GET_USER_SUCCESS, (user: User) => ({
  user,
}));
export const GetUserFail = createAction(
  GET_USER_FAIL,
  (err: HttpErrorResponse) => ({ err }),
);
export const SetUserLoading = createAction(SET_USER_LOADING);
export const UpdateUser = createAction(UPDATE_USER, (user: Partial<User>) => ({
  user,
}));
export const UpdateUserOptions = createAction(
  UPDATE_USER_OPTIONS,
  (opts: Partial<UserOptions>) => ({ opts }),
);
export const UpdateUserExtras = createAction(
  UPDATE_USER_EXTRAS,
  props<Partial<UserExtras>>(),
)
export const InitUserStore = createAction(
  INIT_USER_STORE,
  props<Partial<Omit<UserState, keyof ModelState>>>(),
);
